import { TrackingManager } from "../../../../lib/common/js/services/tracking/trackingManager"

export default (popupStepPath, popupSecondStepPath) => ({
  initExitIntentPopup() {
    if (!this.store.shouldShowExitIntentPopup()) return

    const handleExitIntent = async (e) => {
      const triggeredExitIntent = this.store.isG2Variant() ? this.store.values.trialExitIntent : this.store.values.exitIntent
      
      if (!triggeredExitIntent && e.clientY < 0) {
        window.removeEventListener("mouseout", handleExitIntent)
        const popupRedirectPath = this.store.values.exitIntent && this.store.isG2Variant() ? popupSecondStepPath : popupStepPath
        const tokenPath = this.store.values.token
          ? `${popupRedirectPath}#stored-token=${this.store.values.token}`
          : popupRedirectPath
        window.location.replace(tokenPath)
      }
    }

    window.addEventListener("mouseout", handleExitIntent)
  },

  async closePopup({ clickName } = {}) {
    const internalTracker = new TrackingManager(
      window.trackingConfig.enabledTrackingServices,
      pipelineConfig
    )
    this.store.values.showDiscountModal = false
    this.store.values.exitIntent = true
    await this.store.push()
    window.scrollTo(0, 0)
    
    clickName = clickName || "Get Discount Selected"
    internalTracker.trackClick({ clickName })
  },
})
